import { useState } from "react";
import { Button } from "@mui/material";
import Flex from "../../../../../../../components/Flex";
import SideSheetDrawer from "../../../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../../../hooks/use-disclosure";
import Text from "../../../../../../../components/Text";
import ViewRichTextEditor from "../../../../../../../components/viewRichTextEditor";
import RichTextEditor from "../../../../../../../components/richTextEditor/RichTextEditor";

const ViewEmail = ({
  disclosureHost,
  title,
  showReply,
  onSendReply,
}: {
  disclosureHost: DisclosureHost;
  title?: string;
  showReply?: boolean;
  onSendReply?: (replyBody: string, emailData: any) => void;
}) => {
  const [replyBody, setReplyBody] = useState("");

  const handleClose = () => {
    setReplyBody("");
    disclosureHost.close();
  };

  const handleSend = () => {
    if (onSendReply) {
      onSendReply(replyBody, disclosureHost.data);
    }
    setReplyBody("");
  };

  return (
    <SideSheetDrawer
      open={disclosureHost.opened}
      onClose={handleClose}
      title={title || "View Template"}
      w="600px"
    >
      {disclosureHost.data && (
        <Flex flexDirection={"column"} gap={1}>
          <Text variant="h4" fontWeight={"medium"}>
            Subject: {disclosureHost.data.subject}
          </Text>
          <ViewRichTextEditor
            value={disclosureHost.data.emailBody}
            minHeight={showReply ? 300 : 600}
            maxHeight={showReply ? 300 : 600}
          />
          {showReply && (
            <Flex flexDirection={"column"} gap={1}>
              <Text variant="h4" fontWeight={"medium"}>
                Reply
              </Text>
              <RichTextEditor
                name="replyBody"
                value={replyBody}
                onChange={(e) => setReplyBody(e.target.value)}
                placeholder="Type your reply here..."
                minRows={5}
              />
              <Flex justifyContent={"flex-end"}>
                <Button
                  variant="contained"
                  onClick={handleSend}
                  disabled={!replyBody.trim()}
                >
                  Send
                </Button>
              </Flex>
            </Flex>
          )}
        </Flex>
      )}
    </SideSheetDrawer>
  );
};

export default ViewEmail;
